import {
  CheckboxFacetGroup,
  FacetOption,
} from '@tailwindComponents/CheckboxFacetGroup';
import { RailPanel } from '@tailwindComponents/RailPanel';
import { SupplierFacetState } from './supplierFacets';

export interface SupplierFacetRailProps {
  facets: SupplierFacetState;
  sourceTypeOptions: FacetOption[];
  brandOptions: FacetOption[];
  coverageOptions: FacetOption[];
  onToggleSourceType: (value: string) => void;
  onToggleBrand: (value: string) => void;
  onToggleCoverage: (value: string) => void;
}

export function SupplierFacetRail({
  facets,
  sourceTypeOptions,
  brandOptions,
  coverageOptions,
  onToggleSourceType,
  onToggleBrand,
  onToggleCoverage,
}: SupplierFacetRailProps) {
  return (
    <aside className='flex w-[260px] shrink-0 flex-col gap-4'>
      {sourceTypeOptions.length > 0 && (
        <RailPanel title='Source type' tagline='typology'>
          <CheckboxFacetGroup
            options={sourceTypeOptions}
            selected={facets.sourceTypes}
            onToggle={onToggleSourceType}
          />
        </RailPanel>
      )}
      {brandOptions.length > 0 && (
        <RailPanel title='Brands supplied' tagline='coverage'>
          <CheckboxFacetGroup
            options={brandOptions}
            selected={facets.brands}
            onToggle={onToggleBrand}
          />
        </RailPanel>
      )}
      {coverageOptions.length > 0 && (
        <RailPanel title='Hierarchy branch' tagline='coverage'>
          <CheckboxFacetGroup
            options={coverageOptions}
            selected={facets.coverage}
            onToggle={onToggleCoverage}
          />
        </RailPanel>
      )}
    </aside>
  );
}
